import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useAlertDialogStore = defineStore('alertDialog', () => {
  const isOpen = ref(false)
  const title = ref("")
  const message = ref("")


  const open = (titleArg: string, messageArg: string) => {
    title.value = titleArg
    message.value = messageArg
    isOpen.value = true
  }
  const close = () => {
    isOpen.value = false
  }

  return { open, close, isOpen, title, message }
})
